import { render, staticRenderFns } from "./nice-success.vue?vue&type=template&id=c8d4219e"
import script from "./nice-success.vue?vue&type=script&lang=js"
export * from "./nice-success.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports